import React from "react";

const Divider = ({height = "30px"}) => <div style = {{height}} ></div >;

export {Divider};
